import React, { createContext } from "react";

const ModalContext = createContext();
ModalContext.displayName = "ModalContext";

export default ModalContext;
